import { useGlobalConfigContext } from '../../global-config/context/globalConfigContext'
import { experimentsTrackEvent } from '../eventTracking'

export const useTrackOptimizelyExperimentEvent = (
  eventName: string,
): (() => void) => {
  const globalPublicConfig = useGlobalConfigContext()
  const trackOptimizelyEvent = (): void => {
    experimentsTrackEvent(globalPublicConfig, eventName)
  }

  return trackOptimizelyEvent
}
